import { HttpResponse, HttpService } from '@application/http.service';
import { Injectable } from '@visiba/instantiation';

interface DemandManagementStatusApiModel {
	Status: MessagingOpenStatus;
	ClosedReason: MessagingClosedReason | null;
	NextOpening: string | null;
}

export type MessagingOpenStatus = 'Inactive' | 'Unavailable' | 'Open' | 'Closed';
export type MessagingClosedReason = 'OutsideMonitoredHours' | 'CapLimitReached' | 'Other';

export interface MessagingOpenStatusResult {
	status: MessagingOpenStatus;
	closedReason: MessagingClosedReason | null;
	nextOpening: string | null;
}

@Injectable()
export class DemandManagementApiService {
	constructor(private readonly httpService: HttpService) {}

	public async getMessagingOpenStatus(receptionId: number): HttpResponse<MessagingOpenStatusResult> {
		const response = await this.httpService.get<DemandManagementStatusApiModel>(
			`/client/v2/receptions/${receptionId}/demand-management/messaging`,
		);
		if (response.err) {
			return Err(response.err);
		}

		return Ok({
			...response.ok,
			data: {
				status: response.ok.data.Status,
				closedReason: response.ok.data.ClosedReason,
				nextOpening: response.ok.data.NextOpening,
			},
		});
	}

	public async getTriageOpenStatus(receptionId: number): HttpResponse<MessagingOpenStatusResult> {
		const response = await this.httpService.get<DemandManagementStatusApiModel>(
			`/client/v2/receptions/${receptionId}/demand-management/triage-entry`,
		);
		if (response.err) {
			return Err(response.err);
		}

		return Ok({
			...response.ok,
			data: {
				status: response.ok.data.Status,
				closedReason: response.ok.data.ClosedReason,
				nextOpening: response.ok.data.NextOpening,
			},
		});
	}
}
